var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelmet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83332 9C3.44443 9 2.66666 9.25 2.66666 10.25C2.66666 11.25 3.44443 11.5 3.83332 11.5H12C12.3889 11.5 13.1667 11.25 13.1667 10.25C13.1667 9.25 12.3889 9 12 9M3.83332 9C3.93055 8.16667 4.18332 6.6875 4.41666 6.1875C4.82407 5.09621 5.80059 4.46223 6.74999 4.1791M3.83332 9H4.99999M12 9C12 8.27083 11.8527 6.88826 11.4167 6.1875C10.7376 5.09621 9.89729 4.46223 9.03489 4.1791M12 9H10.8333M6.74999 4.1791C7.15993 4.05684 7.56482 4 7.91666 4C8.28604 4 8.66252 4.05684 9.03489 4.1791M6.74999 4.1791V7.4375M9.03489 4.1791V7.4375",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/helmet.9f065d33b0a2bb77bcaf556b941dd0ec.svg";
export { ForwardRef as ReactComponent };